<nav class="bm-navbar" role="navigation" aria-label="Main">
  <div class="nav-shell">
    <!-- Left cluster -->
    <div class="cluster left">
      <a class="brand" routerLink="/" aria-label="Home">
        <app-logo [width]="170" />
      </a>

      <!-- Primary links (desktop) -->
      <ul class="menu menu-left" aria-label="Primary">
        <li>
          <a
            class="link"
            routerLink="/"
            [class.active]="isRouterActive('home')"
          >
            Home
          </a>
        </li>
        <li>
          <a
            class="link"
            routerLink="/products"
            [class.active]="isRouterActive('products')"
          >
            Produtos
          </a>
        </li>
        <li>
          <a class="link" routerLink="/" (click)="scrollToElement('howWorks')">
            Como funciona
          </a>
        </li>
        <li>
          <a class="link" routerLink="/" (click)="scrollToElement('about')">
            Sobre nós
          </a>
        </li>
      </ul>
    </div>

    <!-- Right cluster -->
    <div class="cluster right">
      <ul class="menu menu-right" aria-label="Secondary">
        @if(userData()){
        <li class="dropdown" [class.open]="openDropdownId() === 'user'">
          <button
            class="dd-trigger avatar"
            type="button"
            aria-haspopup="menu"
            aria-expanded="{{ openDropdownId() === 'user' }}"
            (click)="toggleDropdown('user', $event)"
          >
            <img
              [src]="
                userData()?.profilePictureUrl ?? '/images/user-avatar.webp'
              "
              alt="profile photo"
              class="w-10 h-10 rounded-full"
            />
            <span class="name">
              {{ userData()?.fullName }}
            </span>
            <span class="chev" aria-hidden="true">▾</span>
          </button>
          <ul class="dd-menu dd-right" role="menu">
            <li role="menuitem">
              <a routerLink="/customer/dashboard">
                <i class="ph-duotone ph-house text-2xl"></i>
                Meu portal
              </a>
            </li>
            <li role="menuitem">
              <a routerLink="/customer/orders">
                <i class="ph-duotone ph-package text-2xl"></i>
                Pedidos
              </a>
            </li>
            <li role="menuitem">
              <a routerLink="/customer/cards">
                <i class="ph-duotone ph-credit-card text-2xl"></i>
                Cartão
              </a>
            </li>
            <li role="menuitem">
              <a routerLink="/customer/profile">
                <i class="ph-duotone ph-user-circle text-2xl"></i>
                Meu perfil
              </a>
            </li>
            <hr class="border-gray-300" />
            <li role="menuitem">
              <button class="aslink" type="button" (click)="logOut()">
                <i class="ph-duotone ph-sign-out text-2xl text-red-400"></i>
                Sair
              </button>
            </li>
          </ul>
        </li>
        }@else{
        <li>
          <a
            pButton
            rounded
            class="btn-secondary-outline btn-small px-8 py-3"
            [routerLink]="['internal/sign-in']"
          >
            Acessar
          </a>
        </li>
        <li>
          <a
            pButton
            rounded
            class="btn-secondary btn-small px-8 py-3"
            [routerLink]="['internal/sign-up']"
          >
            Criar conta
          </a>
        </li>
        }
      </ul>

      <!-- Mobile toggle -->
      <button
        class="hamburger"
        type="button"
        aria-label="Abrir menu"
        aria-controls="mobile-panel"
        aria-expanded="{{ isMobileOpen() }}"
        (click)="toggleMobile()"
      >
        <i class="ph ph-list"></i>
      </button>
    </div>
  </div>

  <!-- Mobile slide-down panel -->
  <div id="mobile-panel" class="mobile-panel" [class.open]="isMobileOpen()">
    <ul class="mobile-list">
      <li>
        <a class="link" routerLink="/" [class.active]="isRouterActive('home')">
          Home
        </a>
      </li>
      <li>
        <a
          class="link"
          routerLink="/products"
          [class.active]="isRouterActive('products')"
        >
          Produtos
        </a>
      </li>
      <li>
        <a class="link" routerLink="/" (click)="scrollToElement('howWorks')">
          Como funciona
        </a>
      </li>
      <li>
        <a class="link" routerLink="/" (click)="scrollToElement('about')">
          Sobre nós
        </a>
      </li>
    </ul>
    <hr />
    <div class="mobile-actions">
      @if(userData()){
      <div class="flex place-content-between">
        <ul class="menu">
          <li class="dropdown" [class.open]="openDropdownId() === 'userMobile'">
            <button
              class="dd-trigger avatar"
              type="button"
              aria-haspopup="menu"
              [aria-expanded]="openDropdownId() === 'userMobile'"
              (click)="toggleDropdown('userMobile', $event)"
            >
              <img
                [src]="
                  userData()?.profilePictureUrl ?? '/images/user-avatar.webp'
                "
                alt="profile photo"
                class="w-10 h-10 rounded-full"
              />
              <span class="name">
                {{ userData()?.fullName }}
              </span>
              <span class="chev" aria-hidden="true">▾</span>
            </button>
            <ul class="dd-menu dd-right" role="menu">
              <li role="menuitem">
                <a routerLink="/customer/dashboard">
                  <i class="ph-duotone ph-house text-2xl"></i>
                  Meu portal
                </a>
              </li>
              <li role="menuitem">
                <a routerLink="/customer/orders">
                  <i class="ph-duotone ph-package text-2xl"></i>
                  Pedidos
                </a>
              </li>
              <li role="menuitem">
                <a routerLink="/customer/cards">
                  <i class="ph-duotone ph-credit-card text-2xl"></i>
                  Cartão
                </a>
              </li>
              <li role="menuitem">
                <a routerLink="/customer/profile">
                  <i class="ph-duotone ph-user-circle text-2xl"></i>
                  Meu perfil
                </a>
              </li>
              <hr class="border-gray-300" />
              <li role="menuitem">
                <button class="aslink" type="button" (click)="logOut()">
                  <i class="ph-duotone ph-sign-out text-2xl text-red-400"></i>
                  Sair
                </button>
              </li>
            </ul>
          </li>
        </ul>
      </div>

      }@else {
      <button
        pButton
        rounded
        class="btn-secondary-outline px-8 py-3"
        [routerLink]="['internal/sign-in']"
      >
        Acessar
      </button>
      <button
        pButton
        rounded
        class="btn-secondary px-8 py-3"
        [routerLink]="['internal/sign-up']"
      >
        Criar conta
      </button>
      }
    </div>
  </div>
</nav>
